import React from 'react';

const CheckIcon2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "10",
    height: "9",
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" },
    className
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.5 5.16113L8.25 0.411133L10 2.16113L3.52942 8.41113L0 5.08763L1.5 3.41113L3.5 5.16113Z",
      fill: "#26BA50"
    }
  )
);
CheckIcon2.displayName = "Icons.CheckIcon2";

export { CheckIcon2 };
//# sourceMappingURL=CheckIcon2.js.map
